<template>
  <section class="pending-events-container bg--white">
    <h3 v-show="pendingBlocks.length > 1" class="center mb--22">
      בלוקים שהוזמנו וממתינים לאישור:
    </h3>
    <div
      v-show="pendingBlocks.length <= 1"
      class="center"
      :class="{ 'mb--22': showPendingBlocks }"
      style="color: #f2c202;"
    >
      קיימת בקשה לחדר ניתוח שטרם אושרה -
      <br class="mobile_only" />
      <span
        class="underline pointer"
        @click="showPendingBlocks = !showPendingBlocks"
      >
        {{ showPendingBlocks ? "הסתר" : "לחץ לצפייה" }}
      </span>
    </div>
    <template v-if="showPendingBlocks || pendingBlocks.length > 1">
      <div
        v-for="block in pendingBlocks"
        :key="block.background_block_id"
        class="relative"
      >
        <div class="label-status status-yellow">
          ממתין לאישור
        </div>
        <h2>
          {{ getDate(block.start) }}
        </h2>
        <div class="bold">
          {{ getTime(block.end) }} - {{ getTime(block.start) }}
        </div>
        <div>{{ block.block_type_name }}</div>
        <div>{{ allRooms[block.resourceId]?.name || "" }}</div>
      </div>
    </template>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PendingBlocks",
  props: {
    pendingBlocks: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["allRooms"])
  },
  data() {
    return {
      showPendingBlocks: false
    };
  },
  methods: {
    getTime(date) {
      return this.$moment(date).format("LT");
    },
    getDate(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    }
  }
};
</script>
